import axios from "axios";

function getTheoTrang(page,size){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/lstt/getall?page="+page+"&size="+size);
};

const LichSuThaoTacService={
  getTheoTrang

};
export default LichSuThaoTacService;
